import React, { Suspense } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import Loader from '../Layout/Loader';
import LayoutRoutes from './LayoutRoutes';
import Signin from '../Auth/Signin';

const Routers = () => (
  <BrowserRouter basename='/'>
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route path='/login' element={<Signin />} />
        <Route path='/*' element={<LayoutRoutes />} />
      </Routes>
    </Suspense>
  </BrowserRouter>
);

export default Routers;
